module.exports = __webpack_public_path__ + "static/img/fwlc.b524c73.png";


//////////////////
// WEBPACK FOOTER
// ./static/deposit/fwlc.png
// module id = 9IzC
// module chunks = 1